import { PAGINATION_DEFAULT_LIMIT } from "./constants";

// function returns the updated pagination data if not then return 1st page
export function paginationData(pagination) {
  return pagination || { offset: 0, limit: PAGINATION_DEFAULT_LIMIT };
}

export const getkwargs = ({
  context,
  company_id,
  model,
  view_type = "form",
}) => {
  return {
    kwargs: {
      context: {
        lang: context.lang,
        tz: context.tz,
        uid: context.uid,
        allowed_company_ids: [company_id],
        params: {
          cids: company_id,
          id: "",
          model: model,
          view_type: view_type,
        },

        search_default_my_quotation: 1,
        display_website: true,
        res_partner_search_mode: "customer",
        show_address: 1,
        show_vat: true,
      },
    },
  };
};

export const getTotalTaxAndAmountADDSaleOrder = (orderLineList) => {
  return orderLineList?.reduce(
    (newValue, currentValue) => {
      const { price_subtotal = 0, price_tax = 0 } = currentValue;
      const subTotal = Number(price_subtotal) || parseInt(price_subtotal) || 0;
      const taxPrice = Number(price_tax) || parseInt(price_tax) || 0;
      return {
        totalTax: newValue.totalTax + taxPrice,
        totalAmount: newValue.totalAmount + subTotal,
      };
    },
    { totalTax: 0, totalAmount: 0 }
  );
};

Array.prototype.max = function () {
  return Math.max.apply(null, this);
};
Array.prototype.min = function () {
  return Math.min.apply(null, this);
};
